import { http } from '@/core/helpers/axiosHelper';
import { Batch } from '../batches/batch.interface';
import { EasypayImportErrorFile } from './easypay-import-error-file.interface';

export class EasypayImportErrorFileService {
   async postEasypayImportErrorFile(data: EasypayImportErrorFile) {
      const formData = new FormData();

      Object.entries(data).forEach(([key, value]) => {
         if (!value) return;

         formData.append(key, value);
      });

      const response = await http.post<Batch>(`/easypay-import-error-file`, formData);
      return response.data;
   }
}
